import { render, staticRenderFns } from "./Facet.vue?vue&type=template&id=daac7ba4&"
import script from "./Facet.vue?vue&type=script&lang=ts&"
export * from "./Facet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports